import React from "react";
import { Paper, Tabs, Tab, Badge } from "@mui/material";
import { Send, Visibility } from "@mui/icons-material";

const TabNavigation = ({ activeTab, onTabChange, inTransitCount }) => {
  return (
    <Paper square elevation={activeTab} sx={{ borderRadius: 0 }}>
      <Tabs
        value={activeTab}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab
          onClick={() => onTabChange("")}
          value=""
          icon={<Send />}
          label="Initiate"
          iconPosition="top"
        />
        <Tab
          onClick={() => onTabChange("logs")}
          value="logs"
          icon={
            <Badge badgeContent={inTransitCount} color="error">
              <Visibility />
            </Badge>
          }
          label="All Movements"
          iconPosition="top"
        />
      </Tabs>
    </Paper>
  );
};

export default TabNavigation;
